import { render, staticRenderFns } from "./PayoutItem.vue?vue&type=template&id=0487e55e&scoped=true&lang=pug&"
import script from "./PayoutItem.vue?vue&type=script&lang=js&"
export * from "./PayoutItem.vue?vue&type=script&lang=js&"
import style0 from "./PayoutItem.vue?vue&type=style&index=0&id=0487e55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487e55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDivider,VRow,VSpacer})
